import { Component, OnInit, OnDestroy } from '@angular/core';
import { CovidService } from '../../covid.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.less']
})
export class CategoriesComponent implements OnInit,OnDestroy {
  data = null;
  categories = null;
  getCategory = null;
  currentCategory = null;
  total = null;
  constructor(private service: CovidService) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.getCategory = this.service.getCategories().subscribe(response => {
      this.data = this.service.cleanData(response);
      this.categories = this.service.countDuplicated(this.data);
      this.total = this.data.length;
      this.currentCategory = 'All';
    });
  }

  showCategory(category) {
    this.currentCategory = category;
  }

  ngOnDestroy() {
    this.getCategory.unsubscribe();
  }



}
